<!-- eslint-disable @intlify/vue-i18n/no-raw-text -->
<template>
  <div
    class="relative w-full overflow-x-hidden bg-[url('https://images.rafflebox.ca/RaffleboxLogos/WebsiteAssets/wordsplash_light_grey.png')] bg-cover bg-top bg-no-repeat px-3 pt-48 pb-10 md:px-10 lg:px-24 lg:pb-24"
  >
    <div
      class="absolute bottom-0 left-0 z-0 h-100 w-full bg-[url('https://images.rafflebox.ca/RaffleboxLogos/WebsiteAssets/purple-oval-bg.svg')] bg-cover bg-top bg-no-repeat lg:h-125"
    ></div>
    <div class="relative z-10 flex w-full flex-col items-center text-white">
      <div class="mb-14 w-75 lg:w-100">
        <img
          src="https://images.rafflebox.ca/RaffleboxLogos/WebsiteAssets/trusted-by-phone-photo.png"
          :alt="t('HomeTrustedBy.imageAlt')"
        />
      </div>

      <div class="flex flex-col items-center">
        <div class="font-family-display mb-6 flex items-center">
          <p class="text-2xl font-bold md:text-5xl lg:text-6xl">$</p>
          <p
            class="bg-rbgreen-450 mx-0.5 rounded-lg px-2 py-0.5 text-2xl font-semibold md:px-3 md:py-1.5 md:text-3xl lg:mx-1.5 lg:text-5xl"
          >
            5
          </p>
          <p
            class="bg-rbgreen-450 mx-0.5 rounded-lg px-2 py-0.5 text-2xl font-semibold md:px-3 md:py-1.5 md:text-3xl lg:mx-1.5 lg:text-5xl"
          >
            0
          </p>
          <p
            class="bg-rbgreen-450 mx-0.5 rounded-lg px-2 py-0.5 text-2xl font-semibold md:px-3 md:py-1.5 md:text-3xl lg:mx-1.5 lg:text-5xl"
          >
            0
          </p>
          <p class="text-3xl font-semibold md:-mb-2.5 md:text-5xl lg:-mb-4">,</p>
          <p
            class="bg-rbgreen-450 mx-0.5 rounded-lg px-2 py-0.5 text-2xl font-semibold md:px-3 md:py-1.5 md:text-3xl lg:mx-1.5 lg:text-5xl"
          >
            0
          </p>
          <p
            class="bg-rbgreen-450 mx-0.5 rounded-lg px-2 py-0.5 text-2xl font-semibold md:px-3 md:py-1.5 md:text-3xl lg:mx-1.5 lg:text-5xl"
          >
            0
          </p>
          <p
            class="bg-rbgreen-450 mx-0.5 rounded-lg px-2 py-0.5 text-2xl font-semibold md:px-3 md:py-1.5 md:text-3xl lg:mx-1.5 lg:text-5xl"
          >
            0
          </p>
          <p class="text-3xl font-semibold md:-mb-2.5 md:text-5xl lg:-mb-4">,</p>
          <p
            class="bg-rbgreen-450 mx-0.5 rounded-lg px-2 py-0.5 text-2xl font-semibold md:px-3 md:py-1.5 md:text-3xl lg:mx-1.5 lg:text-5xl"
          >
            0
          </p>
          <p
            class="bg-rbgreen-450 mx-0.5 rounded-lg px-2 py-0.5 text-2xl font-semibold md:px-3 md:py-1.5 md:text-3xl lg:mx-1.5 lg:text-5xl"
          >
            0
          </p>
          <p
            class="bg-rbgreen-450 mx-0.5 rounded-lg px-2 py-0.5 text-2xl font-semibold md:px-3 md:py-1.5 md:text-3xl lg:mx-1.5 lg:text-5xl"
          >
            0
          </p>
          <p class="text-2xl font-bold md:text-5xl lg:text-6xl">+</p>
        </div>
        <p class="font-family-display mb-2 w-75 text-center text-xl md:w-full lg:text-3xl lg:font-semibold">
          {{ t('HomeTrustedBy.description') }}
        </p>
        <Button v-slot="slotProps" as-child severity="primary" size="large">
          <NuxtLink
            :to="localePath({ name: 'contact-us' })"
            :class="[slotProps.class, 'mt-5 w-75 no-underline lg:my-10']"
          >
            {{ t('HomeTrustedBy.cta') }}
          </NuxtLink>
        </Button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import Button from 'primevue/button';

const localePath = useLocalePath();
const { t } = useI18n();
</script>
